import styled from '@emotion/styled';
import * as React from 'react';
import { RadioButton, type Props as RadioButtonProps } from '../RadioButton';

const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  margin-bottom: 8px;
`;

const Label = styled.label`
  display: inline-block;
`;

const Description = styled.div`
  grid-column: 2;
`;

const RadioButtonWithMargin = styled(RadioButton)`
  margin-right: 8px;
`;

export interface Props {
  inputProps: RadioButtonProps;
  id?: string;
  label: React.ReactElement | string;
  description?: React.ReactElement | string;
}

export const RadioButtonRow: React.FC<Props> = ({
  inputProps,
  label,
  id: explicitId,
  description,
  ...props
}) => {
  let id = React.useId();
  if (explicitId) {
    id = explicitId;
  }
  return (
    <Row {...props}>
      <RadioButtonWithMargin {...inputProps} id={id} />
      <Label htmlFor={id}>{label}</Label>
      {description && <Description>{description}</Description>}
    </Row>
  );
};
